import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { SocketService } from './socket.service';
import { Payment } from '../classes/payment';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class PaymentService {

  constructor(private httpClient: HttpClient, private socket: SocketService, private apiService: ApiService) { }

  public newCard(service: string, payment: {}): Observable<any> {
    return this.httpClient.post(`${this.apiService.apiUrl()}/api/customer/payments/${service}/card`, payment);
  }

  public payment(service: string, payment: {}): Observable<any> {
    return this.httpClient.post(`${this.apiService.apiUrl()}/api/customer/payments/${service}`, payment);
  }

  public get(paymentId: number): Observable<any> {
    return this.httpClient.get(`${this.apiService.apiUrl()}/api/customer/payments/${paymentId}`);
  }

  public search(params: any): Observable<any> {
    return this.httpClient.get(`${this.apiService.apiUrl()}/api/customer/payments`, { params: new HttpParams({ fromObject: params }) });
  }

  public wait(payment: string): Observable<Payment> {
    return this.socket.fromEvent(`payment:${payment}`)
  }
}
